import VenueAPI from '../../services/venue.service'

/* eslint-disable camelcase */
export default {
  namespaced: true,

  state: {
    loading: true,
    loaded: false,
    info: {
      code: 0,
      region: null,
      locale: 'en-US',
      vertical: null,
      name: null,
      logo_thumb: null,
      logo_medium: null,
      telephone: null,
      address: null,
      street_address_line_1: null,
      city: null,
      state: null,
      zip_code: null,
      country: null,
      timezone: null,
      latitude: null,
      longitude: null,
      payment_methods: []
    }
  },

  mutations: {
    setInfo (state, info) {
      state.info = Object.assign({}, state.info, info)
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setLoaded (state, loaded) {
      state.loaded = loaded
    }
  },

  getters: {
    getDisplayAddress: state => {
      return `${state.info.name}<br>
      ${state.info.street_address_line_1}</br>
      ${state.info.city}, ${state.info.state}, ${state.info.zip_code}`
    },
    getTaxAmount: state => {
      return total => {
        let taxTotal = 0
        var applyRates = state.info.tax_rates.filter(
          rate => !rate.price_included
        )

        applyRates.forEach(taxInfo => {
          let rate = taxInfo.rate / 10000
          taxTotal += total * rate
        })

        return taxTotal
      }
    },
    getACH: state => {
      return state.info.payment_methods.includes('ACH')
    },
    useLOQ: state => {
      return /Oregon/i.test(state.info.region)
    }
  },

  actions: {
    loadInfo ({ commit }) {
      commit('setLoading', true)
      commit('setLoaded', false)

      if (window.posabitVenueInfo) {
        commit('setInfo', window.posabitVenueInfo)
        commit('setLoading', false)
        commit('setLoaded', true)
      } else {
        // API Fallback needed for development with `yarn serve`
        // Otherwise the app won't function
        VenueAPI.get()
          .then(response => {
            commit('setInfo', response.data)
            commit('setLoading', false)
            commit('setLoaded', true)
          })
          .catch(err => {
            console.warn(err)
            commit('setLoading', false)
            commit('setLoaded', false)
          })
      }
    }
  }
}
